import { TCropArea } from '../types/TCropArea';

type TDisplayedSize = {
  displayedWidth: number;
  displayedHeight: number;
  naturalWidth: number;
  naturalHeight: number;
};

export function scaleCropToNaturalPixels(crop: TCropArea, size: TDisplayedSize): TCropArea {
  const { displayedWidth, displayedHeight, naturalWidth, naturalHeight } = size;

  if (displayedWidth <= 0 || displayedHeight <= 0) {
    return { x: 0, y: 0, width: naturalWidth, height: naturalHeight };
  }

  const scaleX = naturalWidth / displayedWidth;
  const scaleY = naturalHeight / displayedHeight;

  return {
    x: crop.x * scaleX,
    y: crop.y * scaleY,
    width: crop.width * scaleX,
    height: crop.height * scaleY,
  };
}
